"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/helpSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HelpSectionTitlesItem = {
    key: Key | null | undefined;
    /** Detected variants: "We" | "Reduce Pain" | "& Enhance Overall" | "Through Proper" */
    divText: ReactNode;
    /** Detected variants: "Helps Restore Movement" | "Improve Strength" | "Well Being" | "Procedures." */
    divDivText: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/category/help-img-1.png" | "/Templates/Doccure/img/category/help-img-2.png" | "/Templates/Doccure/img/category/help-img-3.png" | "/Templates/Doccure/img/category/help-img-4.png" */
    src: string;
    /** Detected variants: "title" */
    className?: string;
    /** Detected variants: "help-img" */
    alt?: string;
    /** Detected variants: "img-fluid element-one" */
    imageWithBasePath0ClassName?: string;
};
export type HomeEighteenHelpSectionGeneratedProps = {
    /** Default: "1s" */
    divDiv0Div0DivDataWowDuration?: string;
    /** Default: "shadow" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-4.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HelpSectionTitlesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divImageWithBasePath0ImagePropsSingleton?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-3.png" */
    divImageWithBasePath1ImageSrc?: string;
    divImageWithBasePath1ImageVisible?: boolean;
    divImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    helpSectionTitles: HelpSectionTitlesItem[];
    helpSectionTitlesItemWrapper?: (item: HelpSectionTitlesItem, content: ReactNode) => ReactNode;
    helpSectionTitlesRenderer?: (defaultNode: ReactNode) => ReactNode;
    helpSectionTitlesImageVisible?: boolean;
    helpSectionTitlesImageRenderer?: (item: HelpSectionTitlesItem, defaultNode: ReactNode) => ReactNode;
    helpSectionTitlesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HelpSectionTitlesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeEighteenHelpSectionGenerated: FC<HomeEighteenHelpSectionGeneratedProps> = ({
    divDiv0Div0DivDataWowDuration = "1s",
    divImageWithBasePath0ImageAlt = "shadow",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shadow-4.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    divImageWithBasePath0ImagePropsSingleton,
    divImageWithBasePath1ImageAlt = "shadow",
    divImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/shadow-3.png",
    divImageWithBasePath1ImageVisible,
    divImageWithBasePath1ImageRenderer,
    divImageWithBasePath1ImageProps,
    helpSectionTitles,
    helpSectionTitlesItemWrapper,
    helpSectionTitlesRenderer,
    helpSectionTitlesImageVisible,
    helpSectionTitlesImageRenderer,
    helpSectionTitlesImageProps,
}) => {
    return (
        <div className="section help-section-eighteen">
            <div className="container">
                <div className="help-content-sixteen wow fadeInUp" data-wow-duration={divDiv0Div0DivDataWowDuration}>
                    {renderCollectionNode(
                        helpSectionTitles,
                        (item: HelpSectionTitlesItem) => (
                            <div className={item.className ?? "title"} key={item.key}>
                                {item.divText}
                                {renderItemNode(helpSectionTitlesImageVisible, helpSectionTitlesImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "help-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid element-one"} {...(typeof helpSectionTitlesImageProps === "function" ? helpSectionTitlesImageProps(item) : (helpSectionTitlesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                                {item.divDivText}
                            </div>
                        ),
                        helpSectionTitlesItemWrapper,
                        helpSectionTitlesRenderer
                    )}
                </div>
            </div>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid shadow-1" {...(divImageWithBasePath0ImagePropsSingleton ?? {})} />
            ))}
            {renderNode(divImageWithBasePath1ImageVisible, divImageWithBasePath1ImageRenderer, (
                <SmartImage src={divImageWithBasePath1ImageSrc} alt={divImageWithBasePath1ImageAlt} className="img-fluid shadow-2" {...(divImageWithBasePath1ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeEighteenHelpSectionGenerated;
